module.exports = __webpack_public_path__ + "img/napster.96c4f0be.svg";